import React from 'react';
import PropTypes from 'prop-types';
import {round, isUndefined} from 'lodash'

import Formatters from '../../../shared/utils/Formatters';

const propTypes = {
  hasOverdue:        PropTypes.bool.isRequired,
  amount:            PropTypes.number.isRequired,
  emphasisCharacter: PropTypes.any,
};

const Amount = ({ hasOverdue, amount, emphasisCharacter }) => {
  if (isUndefined(amount)) return null;

  const amountParts = () => {
    const rounded = round(amount, 2);
    const split   = Formatters.amount({ amount: rounded, format: '0,0.00' }).split('.')

    return { raw: rounded, wholeNumber: split[0], decimal: split[1] };
  }

  const amountDecimal = () => {
    const decimal = amountParts().decimal
    return `.${decimal}` || '.00';
  }

  const amountWholeNumber = () => {
    const wholeNumber = amountParts().wholeNumber
    return wholeNumber || '0';
  }

  return (
    <div className='_displayFlex _justifyContent-center _alignItems-flex-start _marginBottom--xxxsmall'>
      <div className='_displayFlex _justifyContent-center _alignItems-flex-start'>
        <span className='-primary _marginTop--xxsmall _marginRight--xxxsmall'>₱</span>
        <h1 className='ultra -primary _marginBottom-none' data-testid='amount-whole-number'>
          {amountWholeNumber()}
        </h1>
        <span className='-primary _marginBottom--xxxsmall _alignSelf-center emphasize'  data-testid='amount-decimal'>
          {amountDecimal()}
        </span>
        {hasOverdue &&
        <h1 className='ultra -primary _marginBottom-none _marginLeft--xxxsmall' data-testid='emphasis-character'>
          {emphasisCharacter}
        </h1>
        }
      </div>
    </div>
  );
}

Amount.propTypes = propTypes;
export default Amount;



// WEBPACK FOOTER //
// ./src/features/PrincipalPaydown/components/Hero/Amount.js